import { active } from "@api/users/active/api";
import { deactive } from "@api/users/deactive/api";
import { employeeCosts } from "@api/users/employeeCosts/api";
import { me } from "@api/users/me/api";
import { setPassword } from "@api/users/setPassword/api";
import { warehouses } from "@api/users/warehouses/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type {
  IUserDto,
  IUserGetAllParams,
  IUsersResponse,
} from "@api/users/types";

import type { IPathBaseParam, IPathByIdParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IUsersResponse>>,
  IPathBaseParam,
  IPaginationParams & IUserGetAllParams
>("users");
const postApis = createPostApi<
  IApiResponse<IUsersResponse>,
  IPathBaseParam,
  IUserDto
>("users");
const getApis = createGetApi<
  IApiResponse<IUsersResponse>,
  IPathByIdParam,
  IUserGetAllParams
>("users");
const patchApis = createPatchApi<
  IApiResponse<IUsersResponse>,
  IPathByIdParam,
  IUserDto
>("users");

export const users = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  me,
  warehouses,
  setPassword,
  active,
  deactive,
  employeeCosts,
};
